import React, { forwardRef, useState, useEffect } from "react";
import AutoSuggest from "../../AtomicAutoSuggest";
import { css, cx } from "emotion";
import ErrorMessage from "../ErrorMessage";
import { defaultStyle } from "./style";

const AutoSuggestRef = ({
	options,
	errorMessage,
	hasError,
	innerRef,
	helperText,
	icon,
	onChange,
	defaultValue,
	onFocus,
	name,
	...rest
}) => {
	const [state, setState] = useState({
		value: "Selecione",
		default: { label: "Selecione", value: null }
	});
	const [allSuggestions, setAllSuggestions] = useState(options);

	useEffect(() => {
		// Life cycle react.
		window.setTimeout(() => {
			options.map(opt => {
				if (opt.value == defaultValue) setState({ value: opt.label, default: opt });
			});
		}, 0);
	}, [defaultValue]);

	const suggestion = (ev, obj) => {
		// mock ev to parent
		let mock = {
			target: {
				name,
				value: obj.suggestion.value
			}
		};
		onChange(mock);

		if (!obj.suggestion.value) {
			setState({
				value: "Selecione",
				default: { label: "Selecione", value: null }
			});
			return;
		}
		setState({
			value: obj.suggestion.label,
			default: obj.suggestion
		});
	};

	const handlerFocus = ev => {
		setAllSuggestions(options);
		setState({
			...state,
			value: null
		});

		!!onFocus && onFocus(ev);
	};

	const handlerBlur = () => {
		setState({
			value: state.default.label,
			default: state.default
		});
	};

	const handlerChange = ev => {
		// If select 'Não encontrado' return filter
		if (ev.target.value === undefined) return;

		let suggs = options.filter(obj => {
			if (obj.label.toLowerCase().indexOf(ev.target.value.toLowerCase()) > -1) return obj;
		});

		suggs.length === 0 && (suggs = [{ label: "Não encontrado", value: null }]);

		setAllSuggestions(suggs);

		setState({
			default: state.default,
			value: ev.target.value
		});
	};
	return (
		<div
			className={cx(
				css`
					${defaultStyle}
				`,
				"form-group",
				{ "has-error": hasError }
			)}
		>
			<AutoSuggest
				{...rest}
				ref={innerRef}
				onSuggestionSelected={suggestion}
				onFocus={handlerFocus}
				onBlur={handlerBlur}
				onChange={handlerChange}
				suggestions={allSuggestions}
				value={state.value}
				hasError={hasError}
				icon="icon-arrow-down"
			/>
			{errorMessage && hasError && <ErrorMessage>{errorMessage}</ErrorMessage>}
			{helperText}
		</div>
	);
};

const AutoSuggestForm = forwardRef((props, ref) => <AutoSuggestRef {...props} innerRef={ref} />);

export default AutoSuggestForm;
